import type { FaireProductEntity } from "../../entity_types/product";

export const p_mjhm8ssxd3: FaireProductEntity = {
  token: "p_mjhm8ssxd3",
  type: "product",
  name: "Strawberry Donut Truffle",
  brandToken: "b_4tkquuuvuh",
  brandName: "The Chocolate Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/ba592f06c77152cb154bac59075c71587a36b14b8438dedba88b61b1bc659389.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ebecd1ee270eabea5d25c662927f39c82c2720fef5da0769033c5472e6cbc90c.jpeg",
  ],
  priceDollars: 2.08,
  description:
    "A Belgian chocolate truffle crafted in the shape of a miniature strawberry donut — playful, creamy, and beautifully balanced.\n\nEach piece features a milk-chocolate base reminiscent of a classic cake donut, topped with smooth white chocolate “frosting” and finished with soft strawberry-pink drizzles for a cheerful touch of color. Inside, a lightly whipped strawberry ganache infused with real dried strawberries delivers a delicate flavor that’s airy, creamy, and refreshingly sweet.\n\nThe flavor captures strawberries and cream with a bright, natural fruitiness — indulgent yet light in every bite.\n\nOur Strawberry Donut Truffle is elegant, shelf-stable, and ready for retail — ideal for cafés, gift shops, and gourmet markets seeking a playful, crowd-pleasing treat that delights the eye as much as the palate.\n\nAvailable in a bulk tray of 28 pieces; perfect for presenting in your candy display case, a domed platter, or for packaging in your own boxes.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:01.422Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
